var render, staticRenderFns
import script from "./HasTableHeaderScrollbarSpacer.vue?vue&type=script&lang=js"
export * from "./HasTableHeaderScrollbarSpacer.vue?vue&type=script&lang=js"
import style0 from "./HasTableHeaderScrollbarSpacer.vue?vue&type=style&index=0&id=656d1a85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports